/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$(document).ready(function() {
  $('.lwt-row').slick({
   slidesToShow: 4,
   slidesToScroll: 4,
   arrows: false,
   dots:true,
   responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  $('.testimonial-row').slick({
   slidesToShow: 3,
   slidesToScroll: 3,
   arrows: true,
   dots:false,
   centerMode:true, 
   centerPadding:'190px',
   responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding:'140px',
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding:'80px'
        }
      },
     {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding:'30px'
        }
      }
    ]
 });
  $('.daily-serving-row').slick({
   slidesToShow: 3,
   slidesToScroll: 3,
   arrows: false,
   dots:true,
   centerMode:true, 
   centerPadding:'190px',
   responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding:'140px',
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding:'80px'
        }
      },
     {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding:'30px'
        }
      }
    ]
 });

  $('.ingredient-tab-head-wrapper').slick({
   slidesToShow: 4,
   slidesToScroll: 2,
   arrows: true,
   dots:false,
   infinite:false,
   responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
 });

  $('.videos_list .video_wp').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   arrows: true,
   dots: true,
   infinite:false,
   adaptiveHeight: true,
   autoplay: true,
   autoplaySpeed: 2000,
   prevArrow: $('.prev'),
   nextArrow: $('.next'),
   slide: '.video_main',
   responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
 });
  
  $('.community-row').slick({
     slidesToShow: 4,
     slidesToScroll: 1,
     arrows: true,
     dots:false,
     infinite:false,
     responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
   });

   $('.twi3_wrap').slick({
     slidesToShow: 5,
     slidesToScroll: 1,
     arrows: false,
     dots:true,
     infinite:false,
     responsive: [
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
          }
        }
      ]
    });
   $('.ll3_wrap').slick({
     slidesToShow: 5,
     slidesToScroll: 1,
     arrows: false,
     dots:true,
     infinite:false,
     responsive: [
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        }
      ]
    });

  $('.mfktestimonials .slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
     autoplaySpeed: 2000,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding:"0px",
    focusOnSelect: true,
    responsive: [
       {
        breakpoint: 768,
        settings: {
          dots: true,
          slidesToShow: 2
        }
      }
      
    ]
  });

  $('.slideshow-secondary-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
     autoplaySpeed: 2000,
    dots: true,
    arrows: false,
  });


  $('.ingredint-head-arrow.left').on('click', function(){
    $('.ingredients-tabs .ingredient-tab-head-wrapper .slick-prev').trigger('click');
  });
  $('.ingredint-head-arrow.right').on('click', function(){
    $('.ingredients-tabs .ingredient-tab-head-wrapper .slick-next').trigger('click');
  });
   // var elem = $(".ingredients-tabs .ingredient-tab-head .ingredient-tab-head-wrapper");
   // var items = elem.children();
  
   // // Inserting Inner
   // items.wrapAll('<div class="ingredient-tab-link-wrapper" id="inner" />');

   // // Inserting Outer
   // elem.find('#inner').wrap('<div id="outer"/>');

   // var outer = $('#outer');

   // var updateUI = function() {
   //   var maxWidth = outer.outerWidth(true);
   //   var actualWidth = 0;
   //   $.each($('#inner >'), function(i, item) {
   //     actualWidth += $(item).outerWidth(true);
   //   });
     
   // };
   // updateUI();
   // $('body').on('click','.ingredint-head-arrow.left',function() {
   //   var leftPos = outer.scrollLeft();
   //   outer.animate({
   //     scrollLeft: leftPos - 200
   //   }, 800);
   // });

   // $('body').on('click','.ingredint-head-arrow.right',function() {
   //   var leftPos = outer.scrollLeft();
   //   outer.animate({
   //     scrollLeft: leftPos + 200
   //   }, 800);
   // });

   // $(window).resize(function() {
   //   updateUI();
   // });


  // $('body').on('click','.ingredients-tabs .ingredient-tab-head-wrapper .ingredient-tab-link ', function(e){
  //   e.preventDefault();
  //   $(this).closest('.ingredient-tab-link-wrapper').find('.ingredient-tab-link').removeClass('active');
  //   $(this).addClass('active');
  //   $(this).closest('.ingredients-tab-wrap').find('.ingredients-tab-content-wrapper .ingredients-tab-content').removeClass('active');
  //   $(this).closest('.ingredients-tab-wrap').find('.ingredients-tab-content-wrapper .ingredients-tab-content[data-src="'+ $(this).attr('data-tab') +'"]').addClass('active');
  // });

  $('body').on('click','.ingredients-tabs .ingredient-tab-head-wrapper .ingredient-tab-link ', function(e){
    e.preventDefault();
    $(this).closest('.ingredients-tabs').find('.ingredient-tab-link').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.ingredients-tab-wrap').find('.ingredients-tab-content-wrapper .ingredients-tab-content').removeClass('active');
    $(this).closest('.ingredients-tab-wrap').find('.ingredients-tab-content-wrapper .ingredients-tab-content[data-src="'+ $(this).attr('data-tab') +'"]').addClass('active');
  });

  $('body').on('change','.ingredients-tabs .ingredients-tab-content .vitamin_list', function(){
    $(this).closest('.ingredients-tab-content').find('.ingredients-tab-text').hide();
    $(this).closest('.ingredients-tab-content').find('.ingredients-tab-text[data-content="'+ $(this).val() +'"]').show();
  });

  $('.know-more').click(function(e){
    e.preventDefault();
    $('.indredients-col').removeClass('active')
    $(this).parents('.indredients-col').addClass('active');
  });
  $('.indredients-back-icon').click(function(e){
    e.preventDefault();
    $(this).parents('.indredients-col').removeClass('active');
  });
  
  // ====
  $('.ingredients-salts-item-image').click(function(e){
    e.preventDefault();
    $('.ingredients-salts-item').removeClass('active')
    $(this).parents('.ingredients-salts-item').addClass('active');
  });
  $('.ingredients-salts-item-inr-back').click(function(e){
    e.preventDefault();
    $(this).parents('.ingredients-salts-item').removeClass('active');
  });
  
  if (window.matchMedia('(max-width: 740px)').matches){
      $('.footer__item-title').click(function(){
        $(this).parents('.footer__item--links').toggleClass('active');
        $(this).parents('.footer__item--links').find('.footer__item-content').slideToggle();
    });
  }
  $('.iit-btn').click(function(e){
    e.preventDefault();
    $('.imapge-popup-bg').addClass('active');
  });
  $('.close-popup').click(function(e){
    e.preventDefault();
    $('.imapge-popup-bg').removeClass('active');
  });
  // $(".ingredient-tab-link-wrapper").flickity();
  // $('.ingredient-tab-link-wrapper').flickity({
  //   cellAlign: 'left',
  //   contain: true,
  //   freeScroll: true
  // });

  $('body').on('click','.videos_list .video_main .slide_video video', function(){
     var videle = $('#'+$(this).attr('id')).get(0);
     if (videle.paused) {      
      videle.pause()
      videle.muted = true;
      $(this).closest('.video_wpp').addClass('paused');
    } else {
      videle.play()
      videle.muted = false;
      $(this).closest('.video_wpp').removeClass('paused');
    }
  });

  $('body').on('click','.videos_list .play-video', function(){
    var video = $(this).closest('.video_wpp').find('.slideVideo').attr('id');
    var videoele = $('#'+video).get(0);
    videoele.play();
    videoele.muted = false;
    $(this).closest('.video_wpp').removeClass('paused'); 
  });

  $(".video_wp").on("afterChange", function (event, slick, currentSlide, nextSlide){
    $('.videos_list').find('.video_main').each(function(){
      var vdid = $(this).find('video').attr('id');
      var videoele = $('#'+vdid).get(0);
      videoele.pause();    
      videoele.muted = false;
      $(this).find('.video_wpp').addClass('paused'); 
    });    
  });

  // $(".video_wp").on("afterChange", function (event, slick, currentSlide, nextSlide) {
  //   var vdid = $(this).find('.video_wp').attr('id');
  //   var videoElement = document.getElementById(vdid);
  //   if (videoElement) {
  //       videoElement.pause();
  //       videoElement.muted = true;
  //       $(this).find('.video_wp').addClass('paused');
  //   } else {
  //       console.error("Video element not found: ", vdid);
  //   }
  // });

  if ($(window).width() < 767) {
    var tophe = $('.product-form .product-form__buy-buttons').offset().top + 80;
    $(window).scroll(function(){    
      console.log($(window).scrollTop(), tophe);
      if ($(window).scrollTop() >= tophe) {
        $('.product-form .product-form__buy-buttons').addClass('fixed');
        $('.product-form').addClass('fixed');
        // $('.product .product__info').css('padding-bottom',$('.product-form .product-form__buy-buttons').outerHeight()+'px');
      }else{
        $('.product-form .product-form__buy-buttons').removeClass('fixed');
        $('.product-form').removeClass('fixed');
        // $('.product .product__info').css('padding-bottom','0px');
      }
    });
  }
  $('.rwt-title').click(function(e){
    e.preventDefault();
    $('.rwt-title').removeClass('active');
    $(this).addClass('active');
    $('.rwc-item').hide();
    
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  $('.well-being_tab').click(function(e){
    e.preventDefault();
    $('.well-being_tab').removeClass('active');
    // $('.well-being_tab-dot').removeClass('active');
    $('.well-being_col').hide();
    
    var activeTab = $(this).attr('href');
    $(`#${activeTab}`).fadeIn();
    $(`.well-being_tab[data-id="${activeTab}"]`).addClass('active');
    // $(`.well-being_tab-dot[data-id="${activeTab}"]`).addClass('active');
    return false;
  });

  $('.clinical_report-button,.clinical_report-popup-close').click(function(){
    $('.clinical_report-popup-main').toggleClass('active');
  });

  $('.exploring-wellness-content-item').first().addClass('active').find('.exploring-wellness-content-item-text').show();
  $('.exploring-wellness-content-item').click(function(){
   $(this).toggleClass('active').siblings().removeClass('active');;
   $(this).find('.exploring-wellness-content-item-text').slideToggle();
    $(this).siblings().find('.exploring-wellness-content-item-text').slideUp();
  });

  const featureItems = document.querySelectorAll(".product-features-item");
    // Function to check if an element is in the viewport
    function isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight - 100 && rect.bottom > 0;
    }
    // Function to handle scroll and show items
    function handleScroll() {
      featureItems.forEach((item) => {
        if (isInViewport(item)) {
          item.classList.add("visible");
        }
      });
    }
    // Run on scroll and on page load
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial check on page load

  // ===============================================
  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }
  
  const bottleImage = document.querySelector(".product-features-image-img2");
  
  if (bottleImage) {
    window.addEventListener("scroll", function () {
      if (isInViewport(bottleImage)) {
        bottleImage.classList.add("visible");
      } else {
        bottleImage.classList.remove("visible");
      }
    });
  
    // Initial check on page load
    if (isInViewport(bottleImage)) {
      bottleImage.classList.add("visible");
    }
  }
  // function isInViewport(el) {
  //   if (!el) return false;
  //     const rect = el.getBoundingClientRect();
  //     return rect.top < window.innerHeight - 50 && rect.bottom > 0;
  //   }
  //   function createHandleScroll(imageElement) {  // Closure function
  //     return function handleScroll() {
  //       if (imageElement && isInViewport(imageElement)) {
  //         imageElement.classList.add("visible");
  //       }
  //     };
  //   }
  //   const bottleImage = document.querySelector(".product-features-image-img2");
  //     if (bottleImage) {
  //     const handleScroll = createHandleScroll(bottleImage); // Create the function with bottleImage
  //     window.addEventListener("scroll", handleScroll);
  //     handleScroll();
  //     } else {
  //     console.error("Element with ID 'myBottleImage' not found.");
  //   }

});

$('.faq-secondary-toggle').click(function() {
  var $accordionList = $(this).closest('.faq-secondary-list');
  var $accordionItem = $(this).closest('.faq-secondary-item');
  var $accordionContent = $(this).next('.faq-secondary-item-content');    
  // Check if the clicked item is already active
  var isActive = $accordionItem.hasClass('active');   
  // Remove active class from all items and slide up all contents
  $accordionList.find('.faq-secondary-item').removeClass('active');
  $accordionList.find('.faq-secondary-item-content').slideUp();    
  if (!isActive) {
      // Add active class and slide down the current item if it was not active
      $accordionItem.addClass('active');
      $accordionContent.slideToggle();
  }
});


$('.our-ethos_wrap').slick({
   slidesToShow: 2,
   slidesToScroll: 1,
   arrows: true,
   dots:true,
   infinite:true,
   responsive: [
    {
      breakpoint: 740,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});
$('.blog-article-row').slick({
   slidesToShow: 2,
   slidesToScroll: 1,
   arrows: false,
   dots:true,
   infinite:true,
   responsive: [
    {
      breakpoint: 740,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

$(".benefits-content_wrap .default-line").height($(".benefits-content_wrap").height());
var items = $(".benefits-content_item"),
timelineHeight = $(".benefits-content_wrap").height(),
greyLine = $('.default-line'),
lineToDraw = $('.draw-line');
var liItem = $('.exploring-wellness-content-item');

// sets the height that the greyLine (.default-line) should be according to `.timeline ul` height

// run this function only if draw line exists on the page
if(lineToDraw.length) {
  $(window).on('scroll', function () {

    // Need to constantly get '.draw-line' height to compare against '.default-line'
    var redLineHeight = lineToDraw.height(),
    greyLineHeight = greyLine.height(),
    windowDistance = $(window).scrollTop(),
    windowHeight = $(window).height() / 2,
    timelineDistance = $(".benefits-content_wrap-outer").offset().top;

    if(windowDistance >= timelineDistance - windowHeight) {
      line = windowDistance - timelineDistance + windowHeight;

      if(line <= greyLineHeight) {
        lineToDraw.css({
          'height' : line + 'px'
        });
      }
    }

    // This takes care of adding the class in-view to the li:before items
    var bottom = lineToDraw.offset().top + lineToDraw.outerHeight(true);
    items.each(function(index){
      var circlePosition = $(this).offset();

      if(bottom > circlePosition.top) {				
        $(this).addClass('in-view');
      } else {
        $(this).removeClass('in-view');
      }
    });
  });

}

  // ===
  $(".product-featured-item-mobile-list .default-linee").height($(".product-featured-item-mobile-list").height())
  var itemss = $(".product-features-item-m"),
  timelineHeightt = $(".product-featured-item-mobile-list").height(),
  greyLinee = $('.default-linee'),
  lineToDraww = $('.draw-linee');
  if(lineToDraww.length) {
    $(window).on('scroll', function () {
      var greyLineHeight = greyLinee.height(),        
      windowDistance = $(window).scrollTop(),
      windowHeight = $(window).height() / 2;
      timelineDistance = $(".product-featured-item-mobile-inr").offset().top;
      if(windowDistance >= timelineDistance - windowHeight) {
        line = windowDistance - timelineDistance + windowHeight;
  
        if(line <= greyLineHeight) {
          lineToDraww.css({
            'height' : line + 'px'
          });
        }
      }
      var bottom = lineToDraww.offset().top + lineToDraww.outerHeight(true);
      itemss.each(function(index){
        var circlePosition = $(this).offset();
  
        if(bottom > circlePosition.top) {				
          $(this).addClass('in-view');
        } else {
          $(this).removeClass('in-view');
        }
      });
    });
  }

  if ($(window).width() < 767) {
    $('body').on('click','.fhw-iner-item-content', function(){
      $(this).toggleClass('active');
      $(this).find('.fhw-iner-item-content-text').slideToggle();
    });
    $('body').on('click','.fhw-iner-item-header', function(){
      $(this).toggleClass('active');
      var head = $(this).data('head');
      $(this).closest('.fhw-iner').find('.fhw-iner-item').each(function(index, element) {
        var text = $(element).data('text');
        if(head == text) {
           $(element).find('.fhw-iner-item-content').toggleClass('active'); 
           $(element).find('.fhw-iner-item-content-text').slideToggle({
              complete: function() {
                  // Scroll the content into view after the toggle animation is complete
                  $(element).find('.fhw-iner-item-content-text')[0].scrollIntoView({
                      behavior: 'smooth', // Smooth scrolling animation
                      block: 'center',   // Align to the center of the viewport
                  });
              }
          });
        }
      });
    });
  }

// EXPLORING WELLNESS JS
function revealOnScroll() {
    const revealItems = document.querySelectorAll('.exploring-wellness-content-item');
    const windowHeight = window.innerHeight;
    revealItems.forEach(item => {
        const itemTop = item.getBoundingClientRect().top;
        // Check if the top of the element is within the viewport
        if (itemTop < windowHeight) {
            item.classList.add('in-vieww');
        } else {
            item.classList.remove('in-vieww');
        }
    });
}
window.addEventListener('scroll', revealOnScroll);
revealOnScroll();

var swiper = new Swiper(".kw-wrap", {
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  loop: true,
  slidesPerView: 2,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 4,
    slideShadows: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  keyboard: {
    enabled: true
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      coverflowEffect: false,
      centeredSlides: false
    }
  }
});

AOS.init();